const map = {
	"./az/common.json": [
		835,
		[
			835
		]
	],
	"./en/common.json": [
		515,
		[
			515
		]
	],
	"./es/common.json": [
		290,
		[
			290
		]
	],
	"./pl/common.json": [
		38,
		[
			38
		]
	],
	"./ru/common.json": [
		389,
		[
			389
		]
	],
	"./tg/common.json": [
		965,
		[
			965
		]
	],
	"./uk/common.json": [
		514,
		[
			514
		]
	],
	"./uz/common.json": [
		31,
		[
			31
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 503;
module.exports = webpackAsyncContext;